import moment from 'moment';
import { DATE_TYPE } from '@/const/types';


export namespace ORIGIN_FORMAT {
  export const NumberFormatOrigin = (item: number | string): string => {
      return item.toLocaleString('fullwide', {useGrouping: false}).replace(
          /(\d)(?=(?:\d{3})+(?:\.|$))|(\.\d\d?)\d*$/g,
          (m: string, s1: string, s2: string) => {
            return s2 || (s1 + ',');
          },
      );
  };

  export const DateFormatOrigin = (item: DATE_TYPE): string => {
    if (item) {
        return moment(item).format('YYYY-MM-DD');
    }
    return '';
  }

  export const DateFormatMinuteOrigin = (item: DATE_TYPE): string => {
    if (item) {
      return moment(item).format('YYYY-MM-DD (HH:mm)');
    }
    return '';
  };

  export const DateFormatDetailOrigin = (item: DATE_TYPE): string => {
    if (item) {
      return moment(item).format('YYYY-MM-DD (HH시 mm분 ss초)');
    }
    return '';
  };
}
